export default __webpack_public_path__ + "static/media/closet4-1024w.2be94eda.webp";